<template>
    <div class="box">
        <div :class="showtop ? 'top-box top-boxs' : 'top-box '">
     

            <img v-if="showtop=='false'" @click="showMEnu" class="topIcon" src="/activity/opportunity/wap/topIcon.png" alt="" />
            <img v-else @click="showMEnu" class="topIcon" src="/activity/opportunity/wap/menu.png" alt="" />
            <img v-if="showtop" class="logo" src="/activity/opportunity/wap/logo.png" alt="" />
            <img v-else class="logo" src="/activity/opportunity/wap/logo.png" alt="" />
        </div>
        <div class="top-menu" v-show="showMenus">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
                background-color="#070507" text-color="#fff" style="border: 0; width: 124px"
                active-text-color="#f00000">
                <el-menu-item index="1">首页</el-menu-item>
                <el-menu-item index="2">发布会直播</el-menu-item>
                <el-menu-item index="3">专家团队介绍</el-menu-item>
                <el-menu-item index="4">会议议程</el-menu-item>
                <el-menu-item index="5">投研报告</el-menu-item>
                <el-menu-item index="6">往届回顾</el-menu-item>
                <el-menu-item index="7">支持媒体</el-menu-item>
                <el-menu-item index="8">关注我们</el-menu-item>
            </el-menu>
        </div>
        <div class="bannerBox">
            <img class="banner" src="/activity/opportunity/wap/banner.png" alt="" />

            <img class="top-title1" src="/activity/opportunity/wap/top-titles.png" alt="" />

            <div class="top-title">
                <div class="area">
                    <span>中国 · 香港</span>
                    <img src="/activity/opportunity/wap/tips.png" alt="">
                </div>
                <div class="time">
                    —— 2026 / 01 / 14 ——
                </div>

            </div>
            <div class="part parts" ref="targetElement1">
                <img class="title" src="/activity/opportunity/wap/title.png" alt="" />

                <div class="newVideoBox">
                  
                    <div class="swiperVideo">
                     
                        <video ref="normalVideo"  class="newVideoBox-video" autoplay="autoplay" muted :src="playUrl" controls></video>
                             
                   
                            <div class=" palycont">
                                <div class="flexs" style="flex-wrap: wrap;">
                                <div class="playbox" v-for="(item,index) in playlist" :key="index" @click="videoPlay(item, index)">
                                    <div>
                                        <span class="tit">{{ item.title }}</span>
                                        <span class="tits">{{ item.title1 }}</span>
                                    </div>
                                    <img v-if="index == playIndex" :src="item.img" alt="">
                                    <img v-else :src="item.imgs" alt="">
                                </div>
                                
                                
                             </div>

                            </div>
                       
                        
                    </div>

                </div>




            </div>

        </div>
        <div class="content">

            <div class="part part2" ref="targetElement2">
                <img class="title" src="/activity/opportunity/wap/title1.png" alt="" />
                <img class="teacher" src="/activity/opportunity/wap/teacher.png" alt="">

            </div>
            <div class="partconts">
                <div class="part part3" ref="targetElement3">
                    <img class="title" src="/activity/opportunity/wap/title2.png" alt="" />
                    <div class="contents">
                        <span>多年投资经验不断总结，不断实践数月精心准备</span>
                        <span>打造<span class="weight">2026年极具参考价值的投资方案内容</span></span>
                        <span>汇集投资干货，极具实操价值</span>
                        <span class="date">2026 / 01 / 14 </span>
                        <span class="tips">该程供参考，实际内容以会议为准</span>
                    </div>
                    <div class="timelist">
                        <div v-for="(item, i) in timeList" class="default" :class="{ 'active': i == activeTab }"
                            :key="i">
                            <span>{{ item.time }}</span>
                            <span class="title">{{ item.title }}</span>
                            <div v-if="item.avatar" class="intradebox">
                                <img class="avatar" :src="item.avatar" alt="" />
                                <div class="intrade">
                                    <span>{{ item.teacher }}</span>
                                    <span class="name">{{ item.name }}</span>
                                    <span v-if="item.names" class="name">{{ item.names }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <p>
                        <img @click="Login" src="/activity/opportunity/wap/login.png" alt="" />

                        <img @click="live800" src="/activity/opportunity/wap/request.png" alt="" />
                    </p>
                    <div class="bottom-text">
                        咨询客服获取投研报告及<span>打开密码</span>
                    </div>
                </div>
                <div class="part part4" ref="targetElement4">
                    <img class="title" src="/activity/opportunity/wap/title3.png" alt="" />


                    <div class="swiperBox">
                        <swiper ref="mySwiper" :options="swiperOption">
                            <div class="swiper-slide">
                                <img src="/activity/opportunity/report2.png" />
                            </div>
                            <div class="swiper-slide">
                                <img src="/activity/opportunity/cover2.png" />
                            </div>
                            <div class="swiper-slide">
                                <img src="/activity/opportunity/report1.png" />
                            </div>
                            <!-- 分页器 -->
                            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
                        </swiper>
                    </div>
                    <div class="conts">
                        <span class="weight">预订研报，抢投资先机</span>
                        <span style="margin-top: 13px;">股市、期货、黄金、外汇、数字货币、房地产</span>
                        <span>具体投资策略一一展开，内容翔实，助您实战一臂之力</span>
                        <span class="leave"><span class="weight">名额有限</span> 送完即止！</span>
                    </div>


                    <p style="margin-top: 0;">
                        <img @click="Login" src="/activity/opportunity/wap/login.png" alt="" />

                        <img @click="live800" src="/activity/opportunity/wap/request.png" alt="" />
                    </p>
                    <div class="bottom-text">
                        咨询客服获取投研报告及<span>打开密码</span>
                    </div>
                </div>
            </div>
            <div class="partconts1">
                <div class="part part6" ref="targetElement5">
                    <img class="title" src="/activity/opportunity/wap/title4.png" alt="" />

                    <div class="history">
                        <div v-for="(item, i) in histotylist" :key="i" class="partlist" @click="handleClick(item.url)">
                            <img :src="item.img" alt="" />
                            <div class="tits">{{ item.title }}</div>
                            <div class="conts">{{ item.cont }}</div>
                            <div class="flexs">
                                <div class="timebox">
                                    <img class="time" src="/activity/opportunity/wap/time.png" alt="">
                                    {{ item.time }}
                                </div>
                                <span class="detail">了解详情 ></span>
                            </div>
                        </div>
                    </div>


                </div>
                <div class="part part7" ref="targetElement6">
                    <img class="title" src="/activity/opportunity/wap/title5.png" alt="" />

                    <img class="other" src="/activity/opportunity/wap/media.png" alt="" />

                </div>
            </div>

            <div class="part part8" ref="targetElement8=7">
                <img class="title" src="/activity/opportunity/wap/title6.png" alt="" />

                <div class="app-box">
                    <div class="codeBody">
                        <div>MT4账户专用版本</div>
                        <div class="codeBox">
                            <div class="codeItem">
                                <Qrcode :link="iosMt4DownloadUrl" :size="126" :iconSize="30" />
                                <div>iOS</div>
                            </div>
                            <div class="codeItem">
                                <Qrcode :link="androidMt4DownloadUrl" :size="126" />
                                <div>Android</div>
                            </div>
                        </div>
                    </div>
                    <div class="codeBody">
                        <div>MT5账户专用版本</div>
                        <div class="codeBox">
                            <div class="codeItem">
                                <Qrcode :link="iosMt5DownloadUrl" :size="126" />
                                <div>iOS</div>
                            </div>
                            <div class="codeItem">
                                <Qrcode :link="androidDownloadUrl" :size="126" />
                                <div>Android</div>
                            </div>
                        </div>
                    </div>
                    <div class="codeBody">
                        <div>下载官方APP，发现更多智富可能</div>
                    </div>
                </div>
                <div class="serveBox">

                    <div class="serveBox-item">
                        <span>1、</span>MT4版本用MT4账户，MT5版本用MT5账户，两者分别 不互通；
                    </div>
                    <div class="serveBox-item">
                        <span>2、</span>
                        <div>
                            本平台2024.8.17日之前开立的是MT4账户，之后开立的 账户以开户时所选账户类型为准，如果不确定，请联系
                            <span class="serveBox-serve" @click="live800">在线客服</span>查询。
                        </div>
                    </div>
                </div>
                <img class="other" src="/activity/opportunity/wap/phone.png" alt="" />
            </div>
        </div>
        <!-- <contactus v-if="!isApp"></contactus> -->
    </div>
</template>

<script>


import Qrcode from '../../../component/Qrcode/index.vue'
import { mapState } from "vuex";
import { queryConfigValue, queryChannelInfo } from "@/apis/common"

export default {
    name: "newReportWap",
    components: {
     
        Qrcode,
    },
    data() {
        return {
            day: "00",
            hour: "00",
            min: "00",
            second: "00",
            curStartTime: "2024-12-18 14:00:00",

            menuList: [
                "发布会直播",
                "团队介绍",
                "会议议程",
                "投研报告",
                "媒体报道",
                "往届回顾",
                "支持媒体",
                "关注我们",
            ],
            showMenus: false,
            targetElements: null,
            // swiper 参数
            swiperOption: {
                slidesPerView: 3,
                // swiper图片之间的间隔
                spaceBetween: 140,
                centeredSlides: true,
                grabCursor: true,
                loop: true,
                preventClicks: true,
                //自动播放
                autoplay: {
                    delay: 4000, //延迟播放下一张图片
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            },
            swiperVideoOption: {
                slidesPerView: 1,
                // swiper图片之间的间隔
                spaceBetween: 0,
                centeredSlides: true,
                grabCursor: true,
                loop: true,
                preventClicks: true,
                //自动播放
                autoplay: {
                    delay: 4000, //延迟播放下一张图片
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            },
            swiperTeacherOption: {
                slidesPerView: 1,
                // swiper图片之间的间隔
                spaceBetween: 50,
                centeredSlides: true,
                grabCursor: true,
                loop: true,
                preventClicks: true,
                //自动播放
                autoplay: {
                    delay: 4000, //延迟播放下一张图片
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            },
            swiperTeacherOption1: {
                slidesPerView: 1,
                // swiper图片之间的间隔
                spaceBetween: 0,
                centeredSlides: true,
                grabCursor: true,
                loop: true,
                preventClicks: true,
                //自动播放
                autoplay: {
                    delay: 4000, //延迟播放下一张图片
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            },
            // 讲师轮播
            step_5_swiperOption: {
                slidesPerView: 2,
                // swiper图片之间的间隔
                spaceBetween: 20,
                centeredSlides: true,
                grabCursor: true,
                loop: true,
                preventClicks: true,
            },
            isVideo: '/activity/opportunity/report.mp4',
            screenWidth: null,
            scroll: Number,
            isApp: false,
            showtop: true,
            timer: null,
            myPlyer: null,
            options: null,
            activeIndex: null,
            currentIndex: 0, // 当前显示的图片的索引
            timer: null, // 自动切换的定时器
            teacherSwiper: [
                "/activity/newReport/wap/1.png",
                "/activity/newReport/wap/2.png",
                "/activity/newReport/wap/3.png",
                "/activity/newReport/wap/4.png",
                "/activity/newReport/wap/5.png",
            ],
            isShowVIdeo: false,
            videoList: [

                [
                    'https://pmnew.blob.core.windows.net/xsnews/cmsimg/%E5%90%B4%E9%BE%99%E8%80%81%E5%B8%88%E8%A7%86%E9%A2%91%E7%BB%88%E6%9E%81%E7%89%88.mp4',
                    ,
                ],
                

            ],
            activeTab: 4,
            timeList: [
                {
                    time: '14:00',
                    title: '会议开场致辞',

                },
                {
                    time: '14:05',
                    title: '美联储重启降息对全球资产影响与数字货币展望',
                    avatar: '/activity/opportunity/avatar3.png',
                    teacher: '吴龙',
                    name: '红狮金融研究院资深分析师',
                },
                {
                    time: '14:35',
                    title: '中国新质生产力爆发对冲全球贸易脱钩断链',
                    avatar: '/activity/opportunity/avatar2.png',
                    teacher: '万良',
                    name: '红狮金融研究院资深分析师',
                },
                {
                    time: '15:05',
                    title: '欧洲受两强夹击，欧洲央行与欧元的出路分析',
                    avatar: '/activity/opportunity/avatar.png',
                    teacher: '马文',
                    name: '红狮金融研究院资深分析师',
                },
                {
                    time: '15:35',
                    title: '美对等关税冲击全球化，2026年投资市场影响',
                    avatar: '/activity/opportunity/avatar1.png',
                    teacher: '明杰',
                    name: '红狮金融研究院资深分析师',
                },
                {
                    time: '16:05',
                    title: '全球政局此消彼长对全球投资盈利的影响',
                    avatar: '/activity/opportunity/avatar4.png',
                    teacher: 'Mandy',
                    name: '财经主持人',
                    names: '嘉宾：吴龙，万良，马文，明杰'
                },
                {
                    time: '16:35',
                    title: '答疑互动环节',

                },
            ],
            histotylist: [
                {
                    img: '/activity/opportunity/cart.png',
                    title: '2025全球投资机会研究报告',
                    cont: '以“全球资产配置”为核心主线，结合中美货币政策、中国经济复苏路径与美国大选变量，深入剖析2025年全球投资热点，并通过圆桌对话与互动问答，凝聚专家共识，助力投资者把握复杂环境下的战略机遇',
                    time: '2024/12/18 14:00~16:35',
                    url:'https://www.rlcproltd.net/#/activity/opportunity/index'
                },
                {
                    img: '/activity/opportunity/cart1.png',
                    title: '2024年全球投资机会研究报告',
                    cont: '深入探讨2024年全球宏观经济格局下的投资机遇，围绕美联储转向、地缘冲突、大宗商品走势及汇率波动，全面展望黄金、房地产、外汇等核心资产的配置策略与未来趋势',
                    time: '2024/01/10 14:00~17:00',
                    url:'https://www.rlcproltd.net/#/activity/tg_9654/index'
                },
                {
                    img: '/activity/opportunity/cart2.png',
                    title: '2023年春夏投资机会研究报告',
                    cont: '聚焦全球宏观政策与地缘风险对资产价格的深远影响，通过美联储政策、俄乌战争及市场热点的多维解析，系统揭示了数字货币、贵金属与股市外汇的投资逻辑与布局方向',
                    time: '2023/03/24 14:00~17:30',
                    url:'https://www.rlcproltd.net/#/activity/newReport/index'
                },
            ],
            playlist: [
                {
                    title: '2026全球投资机会研究报告',
                    title1: '往届回顾',
                    img: '/activity/opportunity/play.png',
                    imgs: '/activity/opportunity/continue.png',
                    url: 'https://pmnew.blob.core.windows.net/xsnews/cmsimg/%E5%90%B4%E9%BE%99%E8%80%81%E5%B8%88%E8%A7%86%E9%A2%91%E7%BB%88%E6%9E%81%E7%89%88.mp4'
                },
                {
                    title: '2025全球投资机会研究报告',
                    title1: '往届回顾',
                    img: '/activity/opportunity/play.png',
                    imgs: '/activity/opportunity/continue.png',
                    url: 'https://oss2.rlcpm002.com/HS/static/imgs/report4.mp4'


                },
                {
                    title: '2024全球投资机会研究报告',
                    title1: '往届回顾',
                    img: '/activity/opportunity/play.png',
                    imgs: '/activity/opportunity/continue.png',
                    url: 'https://oss2.rlcpm002.com/HS/static/imgs/report3.mp4'

                },
                {
                    title: '2023全球投资机会研究报告',
                    title1: '往届回顾',
                    img: '/activity/opportunity/play.png',
                    imgs: '/activity/opportunity/continue.png',
                    url: 'https://oss2.rlcpm002.com/HS/static/imgs/report2.mp4'

                },

            ],
            playUrl: 'https://pmnew.blob.core.windows.net/xsnews/cmsimg/%E5%90%B4%E9%BE%99%E8%80%81%E5%B8%88%E8%A7%86%E9%A2%91%E7%BB%88%E6%9E%81%E7%89%88.mp4',
            playIndex: 0,
            androidMt4DownloadUrl: '',
            androidDownloadUrl: '',
            iosMt4DownloadUrl: '',
            iosMt5DownloadUrl: '',

        };
    },
    computed: {
       
     
    },

    created() {
        // 传给App.vue,不展示tabbar
        this.$emit("controlShow", true);
        if (this.$route.query.isApp) {
            this.isApp = true;
        }
 
        this.$nextTick(() => {
            this.getAndroidDownloadUrl()
            this.getmt5DownloadUrls()
            this.getmt4DownloadUrls()
        })
       
    },
    beforeDestroy() {
        //在 beforeDestroy生命周期函数中销毁定时器
        clearInterval(this.timer);
        this.timer = null;
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
        //获取屏幕尺寸
        this.screenWidth = document.body.clientWidth;
        window.onresize = () => {
            //屏幕尺寸变化
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })();
        };
       
    },
    watch: {
        screenWidth: function (n) {
            if (n > 500) {
                this.$router.push({
                    name: "opportunityPC",
                });
            }
        },
    },
    methods: {
        videoPlay(item, index) {
           
                
                this.playUrl = item.url;
                this.playIndex = index;
                this.$nextTick(() => {
                    const videoElement = this.$refs.normalVideo;
                    if (videoElement) {
                        videoElement.play().catch(err => {
                            console.log('视频播放失败:', err);
                        });
                    }
                });
            
        },
        handleClick(url) {
            window.open(url);
        },
       
        toVIdeo() {
            window.open("https://www.rlcproltd.net/#/activity/classRoom/index");

        },
        getTime() {
            let times = new Date('2024-12-18 14:00:00').getTime()

            let time = new Date().getTime()
            console.log(times, time)
            if (time >= times) {
                this.isShowVIdeo = true
                this.init()

            } else {
                this.isShowVIdeo = false
            }
        },
        toUrl() {
            window.open("https://www.rlcproltd.net/#/activity/tg_9654/index");
        },
        toUrl1() {
            window.open("https://www.rlcproltd.net/#/activity/newReport/index");
        },
        // 选择导航
        handleSelect(key) {
            console.log(key);
            this.$emit("getKey", key);
            sessionStorage.setItem("key", key);
            // this.getSessinKey(key);
            switch (key) {
                case "1":
                    this.activeIndex = key;

                    // this.targetElements = this.$refs.targetElement;
                    this.scrollToTarget();
                    this.$refs.videoPlayer.play();

                    break;
                case "2":
                    this.activeIndex = key;
                    this.targetElements = this.$refs.targetElement1;

                    this.scrollToTarget();

                    break;
                case "3":
                    this.activeIndex = key;
                    this.targetElements = this.$refs.targetElement2;

                    this.scrollToTarget();

                    break;
                case "4":
                    this.activeIndex = key;
                    this.targetElements = this.$refs.targetElement3;

                    this.scrollToTarget();

                    break;
                case "5":
                    this.activeIndex = key;
                    this.targetElements = this.$refs.targetElement4;

                    this.scrollToTarget();

                    break;
                case "6":
                    this.activeIndex = key;
                    this.targetElements = this.$refs.targetElement5;

                    this.scrollToTarget();

                    break;
                case "7":
                    this.activeIndex = key;
                    this.targetElements = this.$refs.targetElement6;

                    this.scrollToTarget();

                    break;

                case "8":
                    this.activeIndex = key;

                    this.targetElements = this.$refs.targetElement7;

                    this.scrollToTarget();

                    break;
            }
        },
        // 滚动导航
        scrollToTarget() {
            const targetPosition = this.targetElements.offsetTop;
            window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
            });
        },
        // 显示导航菜单
        showMEnu() {
            this.showMenus = !this.showMenus;
        },
        goBack() {
            window.location.href = window.location.origin;
        },
        live800() {
            window.open(this.$parent.live800UrlUc);
        },
        Login() {
            window.open("https://www.rlcvipltd.net/uc/login");
        },
      
      
        // 控制顶部导航栏的定位
        handleScroll() {
            let scrollY = window.scrollY; //获取滚动后的高度
            console.log(scrollY);
            if (scrollY > 500) {
                this.showtop = false;
            } else {
                this.showtop = true;
            }
        },
        // 下载报告书
        downloadReport() {
            window.open(
                "https://oss.0790jiaxiao.com/Report/SpingSummerInvestment2023032801.pdf"
            );
        },
        // 获取老师直播回放
        async playBack() {
            const data = {
                platid: 1,
                sort: "ut,DESC",
                type: 0,
                page: 0,
                size: 10,
            };
            await this.$store.dispatch("home/getPlayBack", data);
        },
        // 跳转视频回放
        goVideo(attr) {
            // console.log(this.teacherPlayBack);
            switch (attr) {
                case 0:
                    window.open(this.teacherPlayBack[4].fpath);
                    break;
                case 1:
                    window.open(this.teacherPlayBack[3].fpath);
                    break;
                case 2:
                    window.open(this.teacherPlayBack[2].fpath);
                    break;
                case 3:
                    window.open(this.teacherPlayBack[1].fpath);
                    break;
                case 4:
                    window.open(this.teacherPlayBack[0].fpath);
                    break;
                default:
                    break;
            }
        },
        // 获取下载地址

        async getAndroidDownloadUrl() {
            const res = await queryChannelInfo('9999');
            const { downloadUrl = '', mt4UpdateUrl } = res;
            let apkurl = downloadUrl || '';
            const { origin } = window.location;
            const absoluteURLRegex = /^[a-zA-Z]+:\/\/.+/;
            if (absoluteURLRegex.test(downloadUrl)) {
                apkurl = downloadUrl
            } else {
                apkurl = origin + '/' + downloadUrl
            }
            this.androidDownloadUrl = apkurl
            this.iosMt4DownloadUrl = apkurl

        },


        async getmt4DownloadUrls() {
            const res = await queryConfigValue({ key: 'MT4AndroidDownload' });
            console.log(res);

            if (res) {

                let apkurl = res || '';
                const { origin } = window.location;
                const absoluteURLRegex = /^[a-zA-Z]+:\/\/.+/;
                if (absoluteURLRegex.test(res)) {
                    apkurl = res
                } else {
                    apkurl = origin + res
                }


                this.androidMt4DownloadUrl = apkurl

            }

        },
        async getmt5DownloadUrls() {
            const res = await queryConfigValue({ key: 'MT5AndroidDownload' });
            console.log(res);
            if (res) {
                let apkurl = res || '';
                const { origin } = window.location;
                const absoluteURLRegex = /^[a-zA-Z]+:\/\/.+/;
                if (absoluteURLRegex.test(res)) {
                    apkurl = res
                } else {
                    apkurl = origin + res
                }

                this.iosMt5DownloadUrl = apkurl

            }


        }
    },
};
</script>

<style lang="less" scoped>
.top-box {
    width: 100%;
    height: 45px;
    background: #000002;
    position: fixed;
    padding-left: 12px;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;

    .topIcon {
        width: 16px;
        height: 12px;
        margin-right: 20%;
    }

    .logo {
        width: 125px;
    }

    z-index: 9999;
}

.top-boxs {
    background: rgba(0, 0, 2, 0);
}

.top-menu {
    position: fixed;
    top: 40px;
    left: 0;
    width: 124px;
    z-index: 10;

    div {
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 12px;

        text-align: center;
        color: #ffffff;
        opacity: 0.8;
        background: rgba(0, 0, 2, 0.7);
    }

    .acticve {
        color: #f00000;
    }
}

.box {
    width: 100%;
    max-width: 500px;

    .bannerBox {
        width: 100%;
        position: relative;
        padding-bottom: 10%;

        .banner {
            width: 100%;
            // display: block;
        }

        .top-title1 {
            position: absolute;
            top: 6%;
            left: 50%;
            transform: translateX(-50%);
            width: 312px;
            height: auto;

        }

        .top-title {
            position: absolute;
            top: 17%;
            left: 28%;

            .area {
                width: 159px;
                height: 23.5px;
                background: #ffffff;
                box-shadow: -1px 0px 16px 1px rgba(0, 33, 135, 0.04);
                font-size: 10px;
                font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                font-weight: 700;
                text-align: center;
                color: #ea3231;
                text-align: center;
                line-height: 23.5px;

                img {
                    width: 6px;
                    height: 7px;
                    margin-left: 3px;

                }
            }

            .time {
                font-size: 10px;
                font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                font-weight: 700;
                text-align: center;
                color: #000000;
                text-align: center;
                line-height: 23.5px;
                margin-top: 10px;
            }

        }

        .top-slider {
            position: absolute;
            top: 80%;
            left: 15%;
            width: 265px;
            height: 90px;

            img {
                width: 100%;
                height: 90px;
            }

            span {
                color: #fff;

            }

            .day {
                position: absolute;
                left: 29%;
                top: 48%;
            }

            .hours {
                position: absolute;
                left: 46%;
                top: 48%;
            }

            .minute {
                position: absolute;
                left: 63%;
                top: 48%;
            }

            .second {
                position: absolute;
                left: 80%;
                top: 48%;
            }
        }

        .part {
            position: absolute;
            bottom: 0%;
            left: 0;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            margin-top: 16px;


            .title {
                width: 100%;
            }

            .other {
                width: 344px;
            }

            p {
                width: 100%;
                // position: absolute;
                // bottom: 2%;
                // left: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 24px;

                img {
                    width: 127px;
                    margin: 0 10px;
                }
            }

            .live800text {
                width: 120px;
                position: absolute;
                bottom: 1%;
                left: 15%;
            }
        }

        .parts {
            margin: 50px 0;

            .title {
                width: 312px;
                height: auto;
            }

            .contents {
                margin: 11px 1rem 23px;
                width: 300px;
                // height: 32.5px;
                font-size: 12px;

                font-weight: 700;
                text-align: center;
                color: #333333;
                line-height: 20px;

                span {
                    color: #f00000;
                }
            }

            .team {
                // margin-left: 2rem;
                width: 90%;
                margin-bottom: 24px;
            }



            .newVideoBox {
                width: 100%;
                height: 300px;
                position: relative;
                        margin: 0 auto;

                &-video{
                    width: 355px;
                        height: 200px;
                        margin-left: 10px;
                }

                .craig {
                    width: 344px;
                    height: 165px;
                }

              

                .palycont {
                    width: 355px;
                    height: 90px;
                    background: #ffffff;
                    box-shadow: -1px 0px 16px 1px rgba(0, 33, 135, 0.04);
                    padding: 10px 8px;
                    margin: 0 10px;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                }

                .playbox {
                    width: 167px;
                    height: 55px;
                    background: url("/activity/opportunity/wap/active.png") no-repeat;
                    background-size: 100% 100%;
                    padding: 10px 13px 10px 8px;
                    box-sizing: border-box;
                    color: #fff;
                    text-align: left;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 10px;

                    div {
                        display: flex;
                        flex-direction: column;
                    }

                    .tit {
                        width: 84.5px;
                        //  height: 22px;
                        font-size: 10px;
                        font-weight: 700;

                    }

                    .tits {
                        font-size: 8px;
                    }

                    img {
                        width: 20px;
                        height: 20px;
                    }
                                        /deep/.swiper-pagination {
                                            .swiper-pagination-bullet-active {
                                                background: #fff !important;
                                                width: 20px !important;
                                                border-radius: 30% !important;
                                            }
                    
                                            .swiper-pagination-bullet {
                                                width: 10px;
                                                height: 10px;
                                                background: #fff !important;
                    
                                            }
                                        }
                }
            }
        }
    }

    .flexs {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .content {
        width: 100%;
        height: 3060px;

        box-sizing: border-box;


        .part {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;

            position: relative;

            .title {
                width: 100%;
            }

            .other {
                width: 344px;
            }

            p {
                width: 100%;
                // position: absolute;
                // bottom: 2%;
                // left: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 24px;

                img {
                    width: 127px;
                    margin: 0 10px;
                }
            }

            .live800text {
                width: 120px;
                position: absolute;
                bottom: 1%;
                left: 15%;
            }
        }

      

        .part2 {
            background: url("/activity/opportunity/wap/bg.png") no-repeat;
            background-size: 100% 100%;
            margin-top: 0;
            padding-top: 55px;
            margin-top: 10px;

            .title {
                width: 229.5px;
                height: 82px;
                margin-bottom: 24px;
            }

            .teacher {
                width: 98%;
                height: auto;
                padding: 0px 10px 30px;
                box-sizing: border-box;
            }

        }

        .partconts {
            background: url("/activity/opportunity/wap/bg1.png") no-repeat;
            background-size: 100% 100%;
        }

        .partconts2 {
            padding-top: 38px;
            background: url("/activity/opportunity/wap/bg1.png") no-repeat;
            background-size: 100% 100%;
        }

        .part3 {
            padding-top: 50px;



            .title {
                width: 149px;
                height: 74.5px;
            }

            .bottom-text {
                margin: 12px 0 50px;
                font-size: 9px;

                font-weight: 700;
                text-align: center;
                color: #333333;

                span {
                    color: #f00000;
                }
            }

            .contents {
                font-size: 12px;
                font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                font-weight: 700;
                text-align: center;
                line-height: 20px;
                color: #000;
                display: flex;
                flex-direction: column;
                text-align: center;
                margin-top: 24px;

                .weight {
                    color: #ea3130;

                }

                .date {
                    font-family: Bebas Neue, Bebas Neue-Bold;
                    font-size: 30px;
                    background: linear-gradient(to right, #002471 0%, #085ed1 100%);
                    /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
                    -webkit-background-clip: text;
                    /*将设置的背景颜色限制在文字中*/
                    -webkit-text-fill-color: transparent;
                    margin: 20px 0 17px;
                    line-height: 30px;


                }

                .tips {
                    font-size: 8px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                    text-align: center;
                    color: #b3b3b3;
                    margin-bottom: 12px;
                }
            }



            p {
                bottom: 5%;
            }

            .live800text {
                bottom: 1.2%;
            }

            .timelist {
                display: flex;
                flex-direction: column;

                .default {
                    width: 355px;
                    // height: 60px;
                    padding: 20px 0 20px 13px;
                    box-sizing: border-box;
                    background: rgba(255, 255, 255, 0.60);
                    box-shadow: -1px 0px 16px 1px rgba(0, 33, 135, 0.04), 0px 0px 0.4px 0px #ffffff inset;
                    margin-bottom: 10px;
                    color: #000;

                    font-size: 9px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                    font-weight: 700;
                    text-align: left;
                    color: #000000;
                    line-height: 12px;
                    display: flex;

                    .title {
                        width: 119.5px;
                        height: 21.5px;
                    }

                    .avatar {
                        width: 25px;
                        height: 25px;
                        margin-right: 6px;
                    }

                    .intradebox {
                        display: flex;
                    }

                    .intrade {
                        display: flex;
                        flex-direction: column;

                        .name {
                            font-size: 8px;
                            color: #666;
                        }
                    }

                    .title {
                        margin: 0 30px 0 17px;
                    }


                }

                .active {
                    background: url("/activity/opportunity/wap/active.png") no-repeat;
                    background-size: 100% 100%;
                    color: #fff;

                    .intrade {
                        .name {
                            color: #fff;
                        }
                    }
                }
            }
        }

        .part4 {
            padding: 0px 0 42.5px 0;


            .title {
                width: 223.5px;
                height: 74.5px;
            }

            .conts {
                font-size: 12px;
                font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                font-weight: 700;
                text-align: center;
                color: #000;
                line-height: 15px;
                display: flex;
                flex-direction: column;
                margin-top: 23px;

                .weight {
                    color: #ea3130;

                }

                .leave {
                    font-size: 14px;
                    margin: 13px 0 23px;
                }
            }

            .bottom-text {
                margin: 12px 0 0px;
                font-size: 9px;

                font-weight: 700;
                text-align: center;
                color: #000;

                span {
                    color: #f00000;
                }
            }



            p {
                bottom: 3%;
            }

            .download {
                width: 175px;
                position: absolute;
                top: 28%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            .swiperBox {
                width: 90%;


                .swiper-container {
                    width: 100%;
                    height: 260px;

                    .swiper-wrapper {
                        .swiper-slide {
                            img {
                                width: 140px;
                                object-fit: cover;

                            }

                            /* Center slide text vertically */
                            display: -webkit-box;
                            display: -ms-flexbox;
                            display: -webkit-flex;
                            display: flex;
                            -webkit-box-pack: center;
                            -ms-flex-pack: center;
                            -webkit-justify-content: center;
                            justify-content: center;
                            -webkit-box-align: center;
                            -ms-flex-align: center;
                            -webkit-align-items: center;
                            align-items: center;
                            transition: 300ms;
                            transform: scale(1);
                        }

                        .swiper-slide-active,
                        .swiper-slide-duplicate-active {
                            transform: scale(1.2);
                        }
                    }
                }
            }
        }




        .part6 {


            .title {
                width: 223px;
                height: 74.5px;
            }

            .history {
                padding: 24px 10px 80px;
                width: 100%;
                box-sizing: border-box;

            }

            .partlist {
                cursor: pointer;
                padding: 24px 13px;
                background: rgba(255, 255, 255, 0.60);
                box-shadow: -1px 0px 16px 1px rgba(0, 33, 135, 0.04), 0px 0px 0.4px 0px #ffffff inset;
                margin-bottom: 18px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;

                text-align: left;
                line-height: 15px;

                img {
                    height: 118px;
                    width: 100%;
                }

                .tits {
                    font-size: 12px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                    font-weight: 700;

                    color: #000000;
                    margin: 14px 0 8px;

                }

                .conts {
                    font-size: 9px;

                    color: #999999;
                    line-height: 15px;
                    margin-bottom: 12px;

                }

                .timebox {
                    width: 120px;
                    height: 15px;
                    display: flex;

                    background: rgba(0, 0, 0, 0.02);

                    img {
                        width: 9px;
                        height: 9px;
                        margin-right: 5px;
                    }

                    font-size: 8px;

                    color: #b2b2b2;

                }

                .detail {
                    font-size: 8px;

                    color: #ea3130;

                }
            }



        }

        .part7 {




            .title {
                width: 223px;
                height: 74.5px;
                margin-bottom: 24.5px;
            }


        }

        .partconts1 {
            background: url("/activity/opportunity/wap/bg2.png") no-repeat;
            background-size: 100% 100%;
            padding-top: 38px;
        }

        .part8 {
            padding: 50px 0 78px 0;
            background: url("/activity/opportunity/wap/bg4.png") no-repeat;
            background-size: 100% 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            box-sizing: border-box;

            .title {
                width: 97px;
                height: 74.5px;

            }

            .titles {
                font-size: 12px;

                text-align: center;
                color: #000;
                line-height: 20px;
                margin: 12px 0 20px 0;
            }

            .app-box {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

            }

            .appcode-title {
                font-size: 0.9rem;
                font-size: 12px;
                font-weight: 400;
                text-align: center;
                color: #ff3333;
                line-height: 28px;
                margin-bottom: 13px;
            }

            .codeBody {
                color: #000;
                text-align: center;

                >div:first-child {
                    font-weight: 700;
                    margin-bottom: 20px;
                    font-size: 14px;
                    margin-top: 24px;
                }

                .codeBox {
                    display: flex;
                    justify-content: center;


                    .codeItem {
                        &:first-child {
                            margin-right: 15px;
                        }

                        .canvasCode {
                            border-radius: 6px;
                        }

                        div {
                            line-height: 32px;
                            // line-height: 48px;
                            // background: #e4760b;
                            background: linear-gradient(150deg, #ff2c41 0%, #ff1232 100%),
                                #ff3333;
                            color: #fff;
                            border-radius: 4px;
                            margin-top: 6px;
                            // font-size: 20px;
                            font-size: 14px;
                        }
                    }
                }
            }

            .serveBox {
                font-size: 0.68rem;
                font-size: 12px;
                margin-bottom: 40px;
                padding: 0 30px;
                color: #000;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;

                &-serve {
                    color: red;
                    border-bottom: 1px solid red;
                }

                &-item {
                    display: flex;
                }
            }
        }
    }
}

@media screen and (min-width: 380px) {
    .box .content .part4 .swiperBox[data-v-140245c8] {
        width: 83%;
    }

    .box .content .part4 .download[data-v-140245c8] {
        top: 29%;
    }
}

/deep/ .videoPlayer-dimensions {
    width: 355px;
    height: 200px;
                        margin-left: 10px;
}
</style>
